module.exports = __webpack_public_path__ + "media/webfonts/fa-regular-400-d1d7e3b4.woff";